import '../DeckNav.css';
import { RelationshipsDeckFace } from '../../DeckCardOverviews/BasicWords/RelationshipOv';
import DeckNav from '../DeckNav';
import HeaderNav from '../../Components/Header/Header_Nav/Header_Nav';
//one folder up so use ../
//if two folders away use ../../
import SPLoader from '../../Components/Spinner/SpinnerLoader';
import ResourceBar from '../../Components/Resource/ResourceBar';
import Footer from '../../Components/Footer/Footer';


export default function RelationshipsNav() {
  return (
<div>
  <SPLoader time={0.6}/>
  <HeaderNav GoBack_to={"/BasicWordsNav"}/>
  <h1 className="DeckTitle-nav">Relationships (관계)</h1>
  <ResourceBar DeeperLook_to="/RelationshipsDLook" Dictionary_to="/RelationshipsDictionary"/>
  <h1 className="Header2-nav">Flashcards</h1>
   <div><DeckNav faceCard={RelationshipsDeckFace} title_input=""/> </div>
   <Footer/>
</div>
  )
}